module.exports = __webpack_public_path__ + "static/assets/0ea98c4baa05443789eca57276cb7593.png";